import { render, staticRenderFns } from "./ModalInstagram.vue?vue&type=template&id=24996fe8"
import script from "./ModalInstagram.vue?vue&type=script&lang=js"
export * from "./ModalInstagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports